import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { AiOutlineClose } from "react-icons/ai";
import EditTextPost from "../EditPost/EditTextPost";
import EditPollPost from "../EditPost/EditPollPost";
import EditEventPost from "../EditPost/EditEventPost";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import { styled } from "@mui/material/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { FaComment, FaCommentSlash } from "react-icons/fa";
import EditGroupPost from "./EditGroupPost";

// Make sure to bind modal to your appElement
Modal.setAppElement('#root');

const EditPostModal = ({ open, onClose, pollData, groupData, postData, type}) => {

  console.log(postData,"postData");
  console.log(groupData,"groupData"); 
  
  const {group_name,image}=groupData;
  const {name,profile_image}=groupData.user;
 

  
  
  const [isPostSettingOpen, setIsPostSettingOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("anyone");
  const [selectedCommentOption, setSelectedCommentOption] = useState("Connections only");
  const [switchState, setSwitchState] = useState(false);
  const [commentControl, setCommentControl] = useState(false);

  // Initialize form data from postData
  useEffect(() => {
    if (postData) {
      // Set initial values from postData
      setSelectedOption(postData.privacy || "anyone");
      setSelectedCommentOption(postData.commentSettings || "Connections only");
      setSwitchState(postData.brandPartnership || false);
    }
  }, [postData]);

    const IOSSwitch = styled((props) => (
      <Switch
        focusVisibleClassName=".Mui-focusVisible"
        disableRipple
        {...props}
      />
    ))(({ theme }) => ({
      width: 42,
      height: 26,
      padding: 0,
      "& .MuiSwitch-switchBase": {
        padding: 0,
        margin: 2,
        transitionDuration: "300ms",
        "&.Mui-checked": {
          transform: "translateX(16px)",
          color: "#fff",
          "& + .MuiSwitch-track": {
            backgroundColor: "#0B6623",
            opacity: 1,
            border: 0,
            ...theme.applyStyles("dark", {
              backgroundColor: "#2ECA45",
            }),
          },
          "&.Mui-disabled + .MuiSwitch-track": {
            opacity: 0.5,
          },
        },
        "&.Mui-focusVisible .MuiSwitch-thumb": {
          color: "#33cf4d",
          border: "6px solid #fff",
        },
        "&.Mui-disabled .MuiSwitch-thumb": {
          color: theme.palette.grey[100],
          ...theme.applyStyles("dark", {
            color: theme.palette.grey[600],
          }),
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.7,
          ...theme.applyStyles("dark", {
            opacity: 0.3,
          }),
        },
      },
      "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: 22,
        height: 22,
      },
      "& .MuiSwitch-track": {
        borderRadius: 26 / 2,
        backgroundColor: "#E9E9EA",
        opacity: 1,
        transition: theme.transitions.create(["background-color"], {
          duration: 500,
        }),
        ...theme.applyStyles("dark", {
          backgroundColor: "#39393D",
        }),
      },
    }));
    const BpIcon = styled("span")(({ theme }) => ({
      borderRadius: "16px",
      width: "100%",
      padding: "10px 10px",
      border: "5px solid #ccc",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.3s ease-in-out",
      backgroundColor: "#fff",
      cursor: "pointer",
  
      "input:hover ~ &": {
        border: "5px solid black",
      },
  
      "input:checked ~ &": {
        border: "5px solid #0B6623",
        backgroundColor: "#E8F0FE",
      },
    }));
  
    const BpCheckedIcon = styled(BpIcon)({
      // border: "2px solid #0B6623",
      boxShadow: "inset 0 0 0 2px #0B6623",
      backgroundColor: "#E8F0FE",
    });
    function BpRadio(props) {
      return (
        <Radio
          disableRipple
          color="default"
          checkedIcon={<BpCheckedIcon />}
          icon={<BpIcon />}
          {...props}
        />
      );
    }

  function BpRadio(props) {
    return (
      <Radio
        disableRipple
        color="default"
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
        {...props}
      />
    );
  }

  const handleradiochange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleSwitchChange = (event) => {
    setSwitchState(event.target.checked);
  };

  const handleCommentControl = (event) => {
    setSelectedCommentOption(event.target.value);
  };

  const renderEditForm = () => {   
    switch (type) {
      case "text":
        return <EditTextPost post={postData} onClose={onClose} />;
      case "poll":
        return <EditPollPost poll={pollData} onClose={onClose} />;
      case "grouppost":
        return <EditGroupPost post={postData} onClose={onClose} />;
      case "event":
        return <EditEventPost post={postData} onClose={onClose} />;
      default:
        return <EditTextPost post={postData} onClose={onClose} />;
    }
  };

  const modalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      borderRadius: "16px",
      padding: 0,
      width: "50%",
      maxWidth: "600px",
      minHeight: "300px",
      maxHeight: "90vh",
      overflowY: "auto",
      boxShadow: "0 15px 30px rgba(0,0,0,0.1)",
      backgroundColor: "#fff",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.4)",
      zIndex: 1000,
    },
  };

  return (
    <Modal
      isOpen={open}
      onRequestClose={onClose}
      contentLabel="Edit Post"
      style={modalStyles}
    >
      {isPostSettingOpen ? (
        // Post Settings View
        <div className="p-4">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold">Post Settings</h2>
            <button
              onClick={() => setIsPostSettingOpen(false)}
              className="text-gray-500"
            >
              <AiOutlineClose size={24} />
            </button>
          </div>

          <div className="mb-6">
            <h3 className="font-medium mb-3">Who can see your post?</h3>
            <div className="space-y-3">
              <div className="flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
                  <div>
                    <p>Anyone</p>
                    <p className="text-sm text-gray-500">
                      Anyone on or off LinkUP
                    </p>
                  </div>
                </div>
                <Radio
                  checked={selectedOption === "anyone"}
                  onChange={handleradiochange}
                  value="anyone"
                  name="privacy-option"
                />
              </div>
              <div className="flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
                  <div>
                    <p>Connections Only</p>
                    <p className="text-sm text-gray-500">
                      Only your connections
                    </p>
                  </div>
                </div>
                <Radio
                  checked={selectedOption === "connections-only"}
                  onChange={handleradiochange}
                  value="connections-only"
                  name="privacy-option"
                />
              </div>
            </div>
          </div>

          <div className="mb-6">
            <div
              className="flex justify-between items-center p-3 hover:bg-gray-50 rounded-lg cursor-pointer"
              onClick={() => setCommentControl(!commentControl)}
            >
              <h3 className="font-medium">Comment control</h3>
              <div className="flex items-center">
                <span className="text-sm text-gray-500 mr-2">
                  {selectedCommentOption}
                </span>
                <span
                  className={`transform ${commentControl ? "rotate-180" : ""}`}
                >
                  ▼
                </span>
              </div>
            </div>

            {commentControl && (
              <div className="mt-2 space-y-3 pl-4">
                <div className="flex items-center justify-between p-2">
                  <div className="flex items-center gap-3">
                    <FaComment className="text-gray-600" />
                    <span>On</span>
                  </div>
                  <Radio
                    checked={selectedCommentOption === "On"}
                    onChange={handleCommentControl}
                    value="On"
                    name="comment-option"
                  />
                </div>
                <div className="flex items-center justify-between p-2">
                  <div className="flex items-center gap-3">
                    <FaCommentSlash className="text-gray-600" />
                    <span>Off</span>
                  </div>
                  <Radio
                    checked={selectedCommentOption === "Off"}
                    onChange={handleCommentControl}
                    value="Off"
                    name="comment-option"
                  />
                </div>
              </div>
            )}
          </div>

          <div className="flex items-center justify-between p-3">
            <div>
              <h3 className="font-medium">Brand partnership</h3>
              <p className="text-sm text-gray-500">
                {switchState ? "On" : "Off"}
              </p>
            </div>
            <FormControlLabel
              control={
                <IOSSwitch
                  checked={switchState}
                  onChange={handleSwitchChange}
                  disabled={selectedOption !== "anyone"}
                />
              }
            />
          </div>

          <div className="flex justify-end space-x-3 mt-6">
            <button
              onClick={() => setIsPostSettingOpen(false)}
              className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              onClick={() => setIsPostSettingOpen(false)}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Save Changes
            </button>
          </div>
        </div>
      ) : (
        // Main Edit View
        <>
          <div className="flex justify-between border-b border-gray-200 items-center mb-4 p-2">
            <div className="flex items-center  gap-3 hover:bg-gray-100 p-3 rounded-lg">
              {type === "poll" || type === "grouppost" ? (
                <div className="relative ">
                  <img
                    src={profile_image || "/Images/user-img.jpg"}
                    alt={group_name || "User"}
                    className="rounded-full w-14 h-14 mr-3"
                  />
                  <img
                    src={image || "/Images/user-img.jpg"}
                    alt={group_name || "User"}
                    className="absolute top-6 left-6  w-10 h-10 "
                  />
                </div>
              ) : (
                <div className=" ">
                  <img
                    src={"/Images/user-img.jpg"}
                    alt="User profile picture"
                    className=" w-10 h-10 "
                  />
                </div>
              )}

              <div>
                <h2 className="font-semibold">{group_name}</h2>
                <button
                  onClick={() => setIsPostSettingOpen(true)}
                  className="text-sm text-blue-600 flex items-center gap-1"
                >
                  <span>{selectedOption}</span>
                  <span>▼</span>
                </button>
              </div>
            </div>
            <button onClick={onClose} className="text-gray-500">
              <AiOutlineClose size={24} />
            </button>
          </div>

          {renderEditForm()}
        </>
      )}
    </Modal>
  );
};

export default EditPostModal;